<template>
  <div class="flex">
    <ul class="imgs">
      <li v-for="(item,index) in myFileList" :key="index">
        <el-image :src="item" :preview-src-list="fileList" style="object-fit: scale-down;"></el-image>
        <span class="delete">
          <!-- <i class="el-icon-zoom-in mr10"></i> -->
          <i class="el-icon-delete" @click="removeFileList(item,index)"></i>
        </span>
      </li>
    </ul>
    <el-upload
      class="upload"
      :limit="limit - this.myFileList.length"
      action="#"
      :multiple="multiple"
      :headers="{access_token: $store.getters.AppInfo.accessToken}"
      list-type="picture-card"
      :before-upload="uploadImg"
      :on-exceed="onExceed"
      :on-change="onChange"
      v-if="imgHide"
    >
    </el-upload>
  </div>
</template>

<script lang="ts">
import OSS from "ali-oss";
import { compressImage } from "../../../assets/javascript/untils";
export default {
  props: {
    fileList: {
      type: Array,
      default: () => [] 
    },
    module: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: 3
    },
    imgHide: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      srcList: [],
      isSwitch: true,
      myFileList: this.fileList,
      myHeaders: {},
      oss: null,
      ids: [],
      ossParmar: {},

      getStsUrl: '',
      getListUploadIdUrl: '',
      getPrivateImgUrl: '',
    };
  },
  created() {
    if (this.module == "inventory") {
      this.getStsUrl = "/wms/app/upload/getSts";
      this.getListUploadIdUrl = "/wms/app/upload/listUploadId";
      this.getPrivateImgUrl = "/wms/app/upload/getPrivateImgUrl";
    } else {
      this.getStsUrl = this.$url.merchatOss.getSts;
      this.getListUploadIdUrl = this.$url.merchatOss.listUploadId;
      this.getPrivateImgUrl = this.$url.merchatOss.getPrivateImgUrl;
    }
  },
  watch: {
    fileList() {
      this.myFileList = this.fileList;
    },
  },
  methods: {
    async confirmImg (file) {
      let ret = await this.$api.post(this.getListUploadIdUrl, {size: 1, module: this.module, securityType: this.ossParmar.securityType, bucketName: this.ossParmar.bucketName})
      if (ret) {
        this.ids = ret;
      }
      console.log(this.myFileList, this.myFileList.length);
      
      if (this.myFileList.length + 1 <= this.limit) {
        try {
          const imgPath = this.module + "/" + this.ids[0] + '.png';
          const result = await this.oss.put(imgPath, file);
          let arr = result.url.split('/');
          let url = this.ossParmar.imgDomain + '/' + arr[3] + '/' + arr[4];
          console.log(url);
          
          if (this.ossParmar.securityType == 'privated') {
            this.$api.get(this.$url.merchatOss.getPrivateImgUrl, {imgUrl: url}).then(ret => {
              if (ret) {
                /**
                 * oldImgUrl 代表 没解密之前的图片地址
                 * newImgUrl 代表 解密之后的图片地址
                 */
                this.$emit("file", {oldImgUrl :url, newImgUrl: ret});
              }
            })
          } else {
            this.$emit("file", url);
          }
        } catch (e) {
          this.$message.warning('页面过期，请重新刷新页面');
          this.getSts();
        }
      } else {
        this.$message.warning(`最多上传 ${this.limit} 张图片`);
      }
    },
    async uploadImg(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG 或 PNG 格式!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
        return false;
      }

      console.log("压缩前文件", file);
      file = await compressImage(file);
      console.log("压缩后文件", file);

      let res = await this.$api.get(this.getStsUrl, {module: this.module })
      if (res) {
        console.log(res);
        this.oss = new OSS({
          region: process.env.VUE_APP_CURRENTMODE == 'production' ? 'oss-cn-shanghai' : 'oss-cn-beijing',
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          bucket: res.bucketName,
          stsToken: res.securityToken,
          securityToken: res.securityToken
        })
        this.ossParmar = res;
        this.confirmImg(file);
      }
    },
    async getSts () {
      let res = await this.$api.get(this.getStsUrl, {module: this.module })
      if (res) {
        this.oss = new OSS({
          region: process.env.VUE_APP_CURRENTMODE == 'production' ? 'oss-cn-shanghai' : 'oss-cn-beijing',
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          bucket: res.bucketName,
          stsToken: res.securityToken,
          securityToken: res.securityToken
        })
        this.ossParmar = res;
      }
    },
    onExceed (file, fileList) {
        // this.$message.error(`剩余 ${this.limit - this.myFileList.length} 张可上传`)
        this.$message.error(`最多上传 ${this.limit} 张图片`)
    }, 
    onChange (file, fileList) {
        
    },
    removeFileList(item, index) {
      let imgUrl = item;
      this.myFileList.splice(index, 1);
      let obj = {
        myFileList: this.myFileList,
        imgUrl
      }
      this.$emit("delete", obj);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/edit.less";
.hide .el-upload--picture-card {
	display: none;
}
.upload {
  display: flex;
  justify-content: center;
}
/deep/ div .el-upload--picture-card {
  background-color: #fff;
  border-radius: 6px;
  box-sizing: border-box;
  width: 84px;
  height: 84px;
  line-height: 84px;
  vertical-align: top;
  background: url("../../../assets/images/new/otherUpload.png");
  background-size: contain;
  background-repeat: no-repeat;
  .icons {
    width: 18px;
    height: 18px;
    color: #DCDEE0;
    font-weight: bold;
  }
}
.el-upload--picture-card i {
  font-size: 20px;
}
.el-upload--picture-card {
  display: flex;
  justify-content: center;
}
.flex {
  display: flex;
  flex-direction: row;
}
ul li {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 84px;
  height: 84px;
  margin: 0 8px 0 0;
  position: relative;
  display: inline-block;
}
.el-image {
  width: 84px;
  height: 84px;
}
.delete {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
  i {
    text-align: center;
    line-height: 84px;
  }
}
</style>